module.exports = __webpack_public_path__ + "static/img/6.a5eb567.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/6/1/eng/6.png
// module id = dFC+
// module chunks = 0